import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { CheckCircle2, ArrowRight } from 'lucide-react';

export function AboutSchool({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const aboutTitle = data.about_title || null;
  const aboutContent = data.about_content || null;
  const aboutImage = data.about_image || null;

  if (!aboutTitle && !aboutContent) return null;

  const highlights = Array.isArray(data.school_highlights) ? data.school_highlights : [];

  return (
    <Box id="about" sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#f8fafc' }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} sx={{ alignItems: 'center' }}>
          {/* Left Column — Content */}
          <Grid size={{ xs: 12, md: aboutImage ? 6 : 12 }}>
            <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 2 }}>
              <Typography variant="subtitle2" fontWeight={700} letterSpacing="0.05em">
                OUR VISION & VALUES
              </Typography>
            </Box>
            {aboutTitle && (
              <Typography
                variant="h2"
                fontWeight={800}
                sx={{
                  fontSize: { xs: '2rem', md: '2.75rem' },
                  color: '#0f172a',
                  lineHeight: 1.2,
                  mb: 3,
                  letterSpacing: '-0.02em',
                }}
              >
                {aboutTitle}
              </Typography>
            )}
            {aboutContent && (
              <Typography
                variant="body1"
                sx={{
                  color: '#475569',
                  fontSize: { xs: '1rem', md: '1.125rem' },
                  lineHeight: 1.8,
                  mb: 4,
                }}
              >
                {aboutContent}
              </Typography>
            )}

            {/* Highlights List if present */}
            {highlights.length > 0 && (
              <Grid container spacing={2} sx={{ mb: 4 }}>
                {highlights.map((item, index) => (
                  <Grid size={{ xs: 12, sm: 6 }} key={index}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <CheckCircle2 size={20} color={primaryColor} />
                      <Typography variant="subtitle2" fontWeight={700} color="#1e293b">
                        {typeof item === 'string' ? item : item.title}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}

            <Button
              component="a"
              href="#admissions"
              variant="contained"
              endIcon={<ArrowRight size={18} />}
              sx={{
                backgroundColor: primaryColor,
                color: '#ffffff',
                fontWeight: 700,
                px: 3.5,
                py: 1.3,
                borderRadius: 2.5,
                textTransform: 'none',
                boxShadow: `0 8px 20px ${primaryColor}40`,
                '&:hover': {
                  backgroundColor: primaryColor,
                  transform: 'translateY(-2px)',
                },
              }}
            >
              Discover Admission Process
            </Button>
          </Grid>

          {/* Right Column — Image */}
          {aboutImage && (
            <Grid size={{ xs: 12, md: 6 }}>
              <Box sx={{ position: 'relative' }}>
                <Box
                  component="img"
                  src={aboutImage}
                  alt={aboutTitle || 'About School'}
                  sx={{
                    width: '100%',
                    height: { xs: 350, md: 480 },
                    objectFit: 'cover',
                    borderRadius: 5,
                    boxShadow: '0 25px 50px -12px rgba(15, 23, 42, 0.25)',
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
}

export default AboutSchool;
